import React from "react";
import { Helmet } from "react-helmet";
import Foto1 from "../img/Foto 1 Santiago de Pachas_Foto Rufino Motta.jpg";
import Foto2 from "../img/Foto 2 OEFA.jpg";
import Foto3 from "../img/foto 3 aruntani.jpg";
import Foto4 from "../img/foto 4 francisco ismodes en moquegua.jpg";
import Foto5 from "../img/foto 5.jpg";
import Foto6 from "../img/Foto 6 Julián Coaguila - Foto Rufino Motta.jpg";
import Rio from "../img/riomargarita.mp4";
import Fondo from "../img/Ilustración para portada_Moquegua.jpg";
import SocialShare from "../components/SocialShare";
import { Fade } from "react-awesome-reveal";
import Author from "../img/rufino.jpeg";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const NotaMoquegua = () => {
  return (
    <>
      <Navbar />
      <div className="nota">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Santiago de Pachas: Un pueblo que agoniza de sed</title>
          <meta
            property="og:title"
            content="Santiago de Pachas: Un pueblo que agoniza de sed"
          />
          <meta
            name="description"
            content="La empresa Aruntani SAC extrajo oro por dos décadas cerca de sus afluentes y tiene sanciones del estado por impactos en el ambiente."
          ></meta>
          <meta
            property="og:url"
            content={
              process.env.REACT_APP_URL + "/santiago-pachas-pueblo-agoniza-sed"
            }
          />
          <meta property="og:image" content={"https://fundacionmohme.org"+Fondo} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image:src" content={"https://fundacionmohme.org"+Fondo} />
        </Helmet>
        <div>
          <header className="">
            <div className="header-bg">
              <img
                className="img-fluid"
                src={Fondo}
                alt="Santiago de Pachas: Un pueblo que agoniza de sed"
              />
            </div>
            <div className="nota-header-content  ">
              <div className="container d-flex justify-content-center flex-column">
                <Fade delay={80} triggerOnce>
                  <h1>Santiago de Pachas: Un pueblo que agoniza de sed</h1>
                  <SocialShare
                    url={
                      process.env.REACT_APP_URL +
                      "/santiago-pachas-pueblo-agoniza-sed"
                    }
                    text="Santiago de Pachas: Un pueblo que agoniza de sed"
                  />
                  <p className="bajada d-none d-lg-block d-md-none">
                    La empresa Aruntani SAC extrajo oro por dos décadas cerca de
                    sus afluentes y tiene sanciones del estado por impactos en
                    el ambiente. Ahora la mina está en un proceso largo de
                    cierre. El Estado ha declarado en emergencia al pueblo, pero
                    aún no hay nada concreto para remediar la cuenca de
                    Coralaque.
                    <br></br>
                    <br></br>
                  </p>
                </Fade>
              </div>
            </div>
          </header>
        </div>
        <main>
          <div className="container">
            <Fade delay={80}>
              <p className="bajada d-none d-block d-lg-none">
                La empresa Aruntani SAC extrajo oro por dos décadas cerca de sus
                afluentes y tiene sanciones del estado por impactos en el
                ambiente. Ahora la mina está en un proceso largo de cierre. El
                Estado ha declarado en emergencia al pueblo, pero aún no hay
                nada concreto para remediar la cuenca de Coralaque.
              </p>
            </Fade>
          </div>
          <div className="container">
            <Fade delay={80}>
              <div className="author d-flex">
                <div className="circle">
                  <img src={Author} className="img-fluid" alt="Luz Marina" />
                </div>
                Por Rufino Motta Huyhua – La República - Moquegua
              </div>
            </Fade>

            <Fade delay={80}>
              <p>
                <span className="capital-letter">A</span> 833 kilómetros al sur
                de Lima, la capital peruana, entre quebradas silenciosas y la
                poca vegetación de Santiago de Pachas, Julián Coaguila Ramos, un
                hombre de 66 años, no quiere saber nada de lo que pasa en el
                Congreso. Tampoco le interesa los conflictos surgidos desde
                Palacios. Este hombre de contextura delgada y cejas pobladas por
                ahora tiene dos preocupaciones: el nuevo coronavirus y la
                carencia de agua saludable.
              </p>

              <p>
                Hace 20 días, una brigada de Salud visitó su comunidad y, tras
                aplicar las pruebas rápidas, confirmaron que no hay ningún
                poblador contagiado. Eso por ahora.
              </p>
              <p>
                En cambio, la carencia de agua saludable es un mal que su pueblo
                viene arrastrando, debido a la contaminación del río Coralaque.
                Durante seis décadas, el agua que baja por la quebrada había
                servido a las comunidades como si fueran venas que irrigan al
                cuerpo.
              </p>
              <p>
                Santiago de Pachas está ubicado a 2,321 metros sobre el nivel
                del mar. La zona urbana está enclavada entre una planicie y los
                cerros. Es un centro poblado del distrito Chojata, provincia
                Sánchez Cerro, en la región Moquegua. Las casas de adobe y techo
                de calamina son muestra del nivel de pobreza que atraviesan sus
                habitantes.
              </p>
              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto1}
                  alt="Vista panorámica de Santiago de Pachas"
                />
                <div className="img-legend">
                  Vista panorámica de Santiago de Pachas – Foto: Rufino Motta
                </div>
              </div>
              <p>
                En sus angostas calles, el sol del mediodía pega fuerte sobre el
                rostro. La gente del lugar suele llevar gorras sobre la cabeza.
                Algunos usan sombreros de paja o de algodón, tipo macora ala
                ancha, además de atuendos de manga larga.
              </p>

              <p>
                Cerca del pueblo, el río Coralaque luce destruido, a tal punto
                que ya nadie puede darse un chapuzón en sus aguas. Hay riesgo de
                contraer problemas dermatológicos o estomacales.
              </p>
              <p>
                Las aguas de este río ya no son cristalinas. El color es más
                bien entre amarillo y naranja intenso. La tonalidad cambió
                drásticamente una tarde de octubre del 2016. Aquel mes, unos
                agricultores decidieron llevar al rebaño de vacunos y ovinos a
                la vertiente para hacerlos beber agua. Los animales que tomaron
                de ese cauce presentaron fatiga, diarrea y en poco tiempo
                adelgazaron. Los ganaderos tuvieron que introducir por la boca
                agua con jabón, como una forma de lavado.
              </p>
              <p>
                La preocupación se apoderó rápidamente de todo el pueblo.
                Discutieron el tema en las asambleas. Unos atribuyeron el hecho
                a un deslizamiento de una colina y otros a la voladura de rocas
                en alguna obra vial.
              </p>
              <p>
                Fue entonces que decidieron enviar una comisión de autoridades y
                dirigentes locales para verificar las causas del problema. Así,
                recorrieron el trayecto del río Coralaque. En el camino se
                cruzaron con alpacas alimentándose de extensos bofedales,
                gracias al agua pura que fluye del subsuelo o baja de la cumbre.
                Luego encontraron un contraste notorio con el agua que venía de
                otras zonas cercanas a las operaciones de la mina
                Florencia-Tucari. La mina le pertenece a la empresa Aruntani
                SAC, que extrajo oro por unas dos décadas.
              </p>
              <p>
                Al llegar a la altura de Titire, una comunidad que es disputada
                por Moquegua y Puno, la delegación encontró algo más: hallaron
                el punto de contaminación que está focalizado entre la
                intersección de dos vertientes, formando una “Y”, metros abajo
                del puente Titire.
              </p>
              <div className="img-container-2">
                
                <video width="100%" height="auto" autoPlay loop>
                  <source src={Rio} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
                <div className="img-legend text-center" style={{marginTop: -4}}>
                  Contraste entre el líquido contaminado que llega del río
                  Margaritani con el agua cristalino del río Titire.
                </div>
              </div>
              <p>
                El río que baja por el lado derecho próximo a la comunidad tiene
                caudal transparente. Una pastora de camélidos sudamericanos les
                dice que ahí el líquido elemento se puede consumir sin ningún
                problema. Pero ocurre lo contrario con el agua que nace en zonas
                aledañas de la mina y desciende por las quebradas Margaritani y
                Apostoloni. En esa confluencia todo se convierte en un río de
                metales pesados. Ese líquido desciende hacía el río Coralaque y,
                al recibir la descarga de otros tributarios, continúa su senda
                hacía el valle de Tambo, en la región Arequipa. En esa
                provincia, los agricultores también reclaman por los efectos de
                la contaminación.
              </p>
              <h2>Faltas reiteradas</h2>
              <p>
                El Organismo de Evaluación y Fiscalización Ambiental (OEFA), que
                depende del Ministerio del Ambiente, ha realizado varias
                supervisiones a la unidad minera Florencia-Tucari. Algunas de
                las acciones de fiscalización se hicieron en el periodo de
                operaciones y tres de ellas concluyeron en sanciones económicas
                a la empresa Aruntani SAC.
              </p>
              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto2}
                  alt="Una de las supervisiones efectuadas en la zona por OEFA"
                />
                <div className="img-legend">
                  Una de las supervisiones efectuadas en la zona por OEFA
                </div>
              </div>
              <p>
                Una primera multa se le aplicó en el 2011, de 50 Unidades
                Impositivas Tributarias (UIT) que en moneda peruana equivale a
                S/210 000. Al año siguiente se le dos multas: una de 12 UIT
                (S/50 400) y la otra de 40 UIT (S/ 172 000). El OEFA precisó que
                estas sanciones se aplicaron por infringir normas mineras y por
                el inapropiado tratamiento de botadero de residuos mineros y
                filtraciones en el tajo de la mina. Según informó el funcionario
                del OEFA, Martín Garzón Herrera, estas quedaron firmes.
              </p>
              <p>
                Hubo una última fiscalización en campo el año 2017. Técnicos de
                la entidad fiscalizadora identificaron 17 puntos de filtraciones
                del depósito de desmonte y del tajo de la mina. Las aguas ácidas
                que salían de la mina tenían contacto con el caudal de los
                afluentes Margaritani y Apostoloni. A raíz de esto, el OEFA
                ordenó a la compañía de capitales nacionales remediar el suelo y
                el lecho de las quebradas.
              </p>
              <p>
                También le advirtió que debía de captar ocho acumulaciones de
                aguas ácidas y otras adicionales en el interior del tajo, para
                conducirlas hacía el sistema de tratamiento. Estas medidas se
                dictaron para garantizar que los cuerpos hídricos de las cuencas
                afectadas recuperen su calidad. La empresa, sin embargo, no
                cumplió. Esto provocó el inició de otra acción administrativa
                que terminó el año pasado con una multa de 40,59 UIT (S/174
                537).
              </p>
            </Fade>
            <Fade delay={80}>
              <div className="container-chart cuadros">
                <h3>SANCIONES IMPUESTAS POR OEFA CONTRA LA MINERA ARUNTAMI</h3>
                <p class="container text-center" style={{fontSize: 14, fontWeight: 500}}>
                  Multas firmes impuestas a la empresa Aruntani SAC vinculadas a
                  la unidad minera Florencia-Tucari, al 14-08-2020
                </p>

                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">N° de expediente</th>
                      <th scope="col" className="text-center">
                        Año de firmeza de la multa
                      </th>
                      <th scope="col" className="text-center">
                        Unidad Fiscalizable
                      </th>
                      <th scope="col" className="text-center">
                        Resolución DFAI
                      </th>
                      <th scope="col" className="text-center">
                        Resolución TFA
                      </th>
                      <th scope="col" className="text-right">
                        Multas en UIT
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1661202</td>
                      <td className="text-center">2011</td>
                      <td className="text-center">Florencia-Tucari</td>
                      <td className="text-center">OSINERGMIN N° 5924</td>
                      <td className="text-center">002-2011-OEFA/TFA</td>
                      <td className="text-right">50</td>
                    </tr>
                    <tr>
                      <td>014-08-MA/R</td>
                      <td className="text-center">2012</td>
                      <td className="text-center">Florencia-Tucari</td>
                      <td className="text-center">307-2012-OEFA/DFSAI</td>
                      <td className="text-center">279-2012-OEFA/TFA</td>
                      <td className="text-right">40</td>
                    </tr>
                    <tr>
                      <td>049-2011-DFSAI/PAS</td>
                      <td className="text-center">2012</td>
                      <td className="text-center">Florencia-Tucari</td>
                      <td className="text-center">231-2012-OEFA/DFSAI</td>
                      <td className="text-center">228-2012-OEFA/TFA</td>
                      <td className="text-right">12</td>
                    </tr>
                    <tr>
                      <td>3108-2018-OEFA/DFAI/PAS</td>
                      <td className="text-center">2019</td>
                      <td className="text-center">Florencia-Tucari</td>
                      <td className="text-center">1490-2019-OEFA/DFAI</td>
                      <td className="text-center">049-2019-OEFA/TFA-SE</td>
                      <td className="text-right">40.59</td>
                    </tr>

                    <tr>
                      <td colspan="5">
                        <strong>Total</strong>
                      </td>
                      <td className="text-right">
                        <strong>142.59</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Fade>
            <Fade delay={80}>
              <p>
                Tantas medidas impuestas y todo fue en vano. Nada colma las
                expectativas de los ciudadanos de Santiago de Pachas. Julián
                Coaguila dice que ya está comprobado el origen minero del daño.
                “El Estado actúa con mano blanda cuando se trata de empresas
                mineras”, concluye.
              </p>
              <p>
                La Autoridad Nacional del Agua (ANA) también hizo siete
                monitoreos sobre la calidad del agua superficial en la Unidad
                Hidrográfica Coralaque, entre los años 2017 y 2020. Estas se
                hicieron en temporada de avenida y estiaje. En uno de los
                estudios se determinó que en los afluentes Margaritani y
                Apostoloni, e incluso en Queullijahuire y Aruntaya, se
                trasgredía los Estándares de Calidad Ambiental (ECA)
                establecidas para categoría 3, es decir riego de vegetales y
                bebida de animales.
              </p>
              <p>
                Para los parámetros de PH, fue detectado el ácido elevado y
                exceso de conductividad eléctrica en las nacientes. También
                encontraron presencia de metales pesados por encima de los
                límites como aluminio, arsénico, boro, cadmio, cobalto, cobre,
                hierro, manganeso, níquel y zinc.
              </p>
              <p>
                En las conclusiones, uno de los informes señala que es probable
                que los aportes de los geiseres (erupción de aguas subterráneas)
                también esté contribuyendo alterar la calidad del agua del río
                Coralaque. Sin embargo, las aguas calientes que brotan del suelo
                se ubican por debajo del puente Bello, a medio kilómetro de la
                unión del río de metales pesados y Titire.{" "}
              </p>
              <p>
                La responsable en calidad de recursos hídricos del área técnica
                de la Autoridad Autónoma del Agua (AAA) Caplina-Ocoña, ingeniera
                Jacqueline Figueroa Zavala, refiere que se tiene un plan de
                trabajo que permitirá realizar estudios más específicos a fin de
                determinar la causalidad de la coloración de los ríos Coralaque
                que más abajo toma el nombre de río Tambo.
              </p>
              <p>
                En tanto, la mina de Florencia-Tucari está en proceso de cierre
                desde hace buen tiempo. En el 2012, la Dirección de Asuntos
                Ambientales del Ministerio de Energía y Minas (Minem) aprobó su
                primer plan. Después, le permitió hacer hasta cuatro
                modificaciones al documento. Aruntani SAC ha pedido una quinta
                ampliación del cronograma que alargaba el cierre hasta diciembre
                del 2023.
              </p>

              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto3}
                  alt="Mina de Florencia-Tucari en un prolongado proceso de cierre."
                />
                <div className="img-legend">
                  Mina de Florencia-Tucari en un prolongado proceso de cierre.
                </div>
              </div>

              <p>
                En junio del 2019, el Ministerio de Energía y Minas (MEM) le
                denegó su solicitud y más bien dispuso ejecutar la garantía por
                US$ 8 millones. No obstante, la carta fianza no se pudo ejecutar
                en su momento porque la empresa presentó un recurso de
                reconsideración para evitar el desembolso. Meses después, el
                Consejo Nacional de Minería declaró improcedente el petitorio
                empresarial.
              </p>
              <p>
                Para la coordinadora de la Oficina Descentralizada del
                Ministerio del Ambiente, María Barrios, esta decisión deja
                camino libre al Estado para que pueda usar el dinero para cerrar
                la mina, aunque advierte que no será suficiente para cumplir ese
                propósito y deberá asumir el costo mayor.
              </p>

              <p>
                El exministro de Energía y Minas Francisco Ísmodes considera que
                este caso es un pésimo ejemplo que le pasa factura al sector
                minería. El Gobierno deberá actualizar el plan de cierre e
                iniciar a ejecutar la fianza. Cuando aún Ísmodes se desempeñaba
                como titular de esa cartera, conformó una comisión
                multisectorial encargada de buscar soluciones y atender a las
                familias afectadas. Han transcurrido meses y aún no hay
                resultados.
              </p>
              <p>
                Para este informe pedimos la versión de la empresa minera
                Aruntani SAC, sin tener respuesta.
              </p>
              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto4}
                  alt="El exministro de Energía y Minas Francisco Ísmodes visitó Moquegua"
                />
                <div className="img-legend">
                  El exministro de Energía y Minas Francisco Ísmodes visitó
                  Moquegua, en julio del 2019, para buscar soluciones frente a
                  la contaminación del río Coralaque.
                </div>
              </div>

              <h2>Impacto en el campo</h2>

              <p>
                En Santiago de Pachas, la agricultura se ha reducido a su mínima
                expresión. Antes del 2016, los campos de sembrío de productos de
                autoconsumo como maíz, papa y trigo se extendían por encima de
                las 350 hectáreas. Las áreas de cultivo han caído a menos de 20
                hectáreas.
              </p>

              <p>
                Julián Coaguila Ramos recuerda que en los mejores tiempos
                cosechaba varios sacos de maíz de sus fundos llamados Pampa
                Soledad y Pampa Blanca. “Cuando regamos con agua contaminada, el
                suelo se ha vuelto improductivo. El maíz ya no crece como
                debería ser y se seca por falta de agua”, sostiene Coaguila,
                ahora alcalde del centro poblado. Los andenes de alfalfa también
                se están secando.
              </p>
              <p>
                Para el consumo humano, la población solo tiene agua entubada.
                El recurso es abastecido a través de una tubería que viene desde
                un ojo de agua, ubicado a unos cinco kilómetros. El recurso es
                escaso y no se puede destinar para la agricultura. Algunos
                campesinos han optado por trasladar agua en bidones a lomo de
                burros para sus vacas.
              </p>
              <p>
                Julián Coaguila Ramos tiene siete hijos. De ellos, el menor de
                todos se ha quedado junto a su padre y madre. Otros han migrado
                a Arequipa y otros a Moquegua. Otras parejas de jóvenes han
                seguido los mismos pasos. Julián asegura que hace 4 años había
                más de un centenar de familias y ahora no hay más de 30. Quienes
                siguen en la villa son en su mayoría los adultos mayores.
              </p>
              <p>
                Uno de ellos es Aquilino Ramos, de 62 años de edad, quien se
                resiste a salir del pueblo. No está dispuesto a abandonar a su
                madre Marcela, de 89 años, y su padre Armando, de 91 años. Mira
                con tristeza caer algunas hojas secas del árbol de manzano
                dentro de su huerto. Hay también plantones de pera y tunas, pero
                ya no dan frutos como cuando recogía de niño.
              </p>
              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto5}
                  alt="Ubicación de Moquegua"
                />
                <div className="img-legend">
                  Ubicación de Moquegua, el centro poblado de Pachas y el
                  campamento minero Florencia – Tucari (Google Maps)
                </div>
              </div>

              <h2>Emergencia sin resultados</h2>
              <p>
                En diciembre del 2019, la Presidencia del Consejo de Ministros,
                a través del Decreto Supremo 188-2019-PCM declaró estado de
                emergencia a cinco distritos por contaminación del recurso
                hídrico. Fueron incluidos Matalaque Qunistaquilla, Omate,
                Coalaque y Chojata.
              </p>
              <p>
                La medida ya fue ampliada en dos ocasiones y está vigente. Esta
                se extendió para facilitar acciones que conduzcan a remediar la
                cuenca. Pero no hay nada concreto a la fecha.
              </p>

              <p>
                El alcalde distrital de Chojata, Priscilio Mamani, asegura que
                la alternativa es trasladar el agua por tuberías desde el sector
                de Matazo, a 27 kilómetros del pueblo. Ha viajado a Lima en más
                de una ocasión para gestionar apoyo para el proyecto que
                demandaría una inversión de 30 millones de soles. Indica que hay
                poco interés de las autoridades del Gobierno para sacar adelante
                esta idea.
              </p>

              <p>
                Tampoco hay decisión política del Gobierno Regional Moquegua
                para hacer suyo el proyecto. La comuna distrital de Chojata
                recibió este año una transferencia de S/ 156 965 por de canon
                minero. El presupuesto general del municipio para el 2020, para
                gastos de inversión, es apenas de un S/ 1 382 687, monto que no
                alcanza ni para los estudios.
              </p>

              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto6}
                  alt="Julián Coaguila Ramos"
                />
                <div className="img-legend">
                  Julián Coaguila Ramos, hoy alcalde del centro poblado de
                  Santiago de Pachas.
                </div>
              </div>

              <p>
                Pese a la situación adversa, hay agricultores que se niegan
                abandonar sus propiedades. Julián Coaguila y su esposa Pilar, de
                63 años, a veces piensan en trasladarse a Moquegua. Julián tiene
                sentimientos encontrados. Considera que al irse renunciaría al
                pueblo donde nació y radicó toda su vida. Santiago de Pachas
                cumplió el pasado 25 de julio 67 años como comunidad y dos años
                como centro poblado. No hubo fiesta con bandas y la chicha de
                maíz. Todo se redujo a una misa con pocos concurrentes en la
                pequeña iglesia.
              </p>

              <p>
                Así, mientras los habitantes de Pachas subsisten a su suerte,
                sin agua potable, sin cultivos y sin agua suficiente para sus
                animales, el Estado se niega a mirar el problema en su
                profundidad.
              </p>
            </Fade>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default NotaMoquegua;
